import { CheckboxData } from '../../../onboarding-component/onboarding-interfaces';
import { VehicleOffersEventDescriptionBase } from '../../../../hooks/react-query/use-vehicle-offers-event-descriptions/use-vehicle-offers-event-descriptions.types';

export interface FilterStatusesProps {
  title: string;
  handleInput: (title: string, value: string[]) => void;
  dropListData: FilterStatusesDropListData[];
  filterForServer: string[] | null;
}

export type FilterStatusesDropListData = Omit<
  VehicleOffersEventDescriptionBase,
  'uds_hierarchie' | 'uds_statusfahrer' | 'uds_statusfahzeugbestellfreigeber'
>;

export interface FilterStatusesCheckboxesState {
  [key: string]: GroupCheckboxesState;
}

export interface GroupCheckboxesState extends CheckboxData {
  items: ItemCheckboxState[];
}

export interface ItemCheckboxState extends CheckboxData {
  id: string;
}

export enum FilterStatusesCheckboxStateTypes {
  Group = 'group',
  Item = 'item'
}
